< !--template for the modal component-- >
<template>
    <div v-if="showModal" v-on:close="showModal = false">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-header">
                            <slot name="header">
                                <h2><strong>¡Atención!</strong></h2>
                            </slot>
                        </div>

                        <div class="modal-body">
                            <slot name="body">
                                <p>Debe aceptar las condiciones para autorizar la consulta a sus datos personales</p>
                            </slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">
                                <button class="modal-default-button btn btn-primary">
                                    Aceptar
                                </button>
                            </slot>

                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    module.exports = {
        props: {
            mostrar: { default: false, type: Boolean },
        },
        data: function () {
            return {
                showModal: false
            }
        },
        watch: {
            mostrar: {
                inmediate: true,
                handler: function (val, oldVal) {
                    if (val) {
                        this.showModal = val;
                    } else if (val == false) {
                        this.$emit('cerrar', false)
                        this.showModal = false;
                    }
                }
            },
            showModal: {
                immediate: true,
                handler: function (val, oldVal) {
                    if (!val) {
                        document.ontouchmove = function (e) { return true; }
                        document.body.style.overflow = "inherit";
                    } else {
                        document.ontouchmove = function (e) { e.preventDefault(); }
                        document.body.style.overflow = "hidden";
                    }
                }
            }
        }
    }
</script>

<style>
    .modal-mask {
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h2 {
        margin-top: 0;
        color: #428bca;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }
</style>



// WEBPACK FOOTER //
// Scripts/js/components/modalCerrarSesion.vue